import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X } from "lucide-react";
import { Logo } from "./Logo";
import { NAV_LINKS } from "../../data/content";

const scrollTo = (href) => {
  if (window.__lenis) {
    window.__lenis.scrollTo(href, { offset: -76, duration: 1.4 });
  } else {
    document.querySelector(href)?.scrollIntoView({ behavior: "smooth" });
  }
};

export const Header = () => {
  const [open, setOpen] = useState(false);

  const go = (e, href) => {
    e.preventDefault();
    setOpen(false);
    scrollTo(href);
  };

  return (
    <header data-testid="site-header" className="fixed top-0 w-full z-50 bg-navy shadow-md">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-[76px] flex items-center justify-between">
        <motion.a
          href="#top"
          data-testid="nav-logo"
          onClick={(e) => go(e, "#top")}
          className="flex items-center group"
          initial={{ opacity: 0, x: -24 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
        >
          <Logo dark={false} />
        </motion.a>

        <nav className="hidden lg:flex items-center gap-7" data-testid="nav-desktop">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={(e) => go(e, l.href)}
              className="text-xs font-semibold uppercase tracking-[0.14em] text-white/85 hover:text-brand transition-colors duration-300"
            >
              {l.label}
            </a>
          ))}
          <button
            data-testid="nav-cta-button"
            onClick={(e) => go(e, "#contact")}
            className="bg-brand text-white text-xs font-semibold uppercase tracking-[0.12em] py-3 px-6 hover:bg-brand-hover transition-colors duration-300"
          >
            Start a Project
          </button>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-white p-2"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      <AnimatePresence>
        {open && (
          <motion.nav
            data-testid="nav-mobile"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: "auto" }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.3 }}
            className="lg:hidden bg-navy border-t border-white/15 overflow-hidden"
          >
            <div className="px-6 py-6 flex flex-col gap-4">
              {NAV_LINKS.map((l) => (
                <a
                  key={l.href}
                  href={l.href}
                  data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                  onClick={(e) => go(e, l.href)}
                  className="text-sm font-semibold uppercase tracking-[0.14em] text-white/85 hover:text-brand transition-colors duration-300"
                >
                  {l.label}
                </a>
              ))}
              <button
                data-testid="nav-mobile-cta-button"
                onClick={(e) => go(e, "#contact")}
                className="bg-brand text-white text-sm font-semibold uppercase tracking-[0.12em] py-3 px-6 mt-2 hover:bg-brand-hover transition-colors duration-300"
              >
                Start a Project
              </button>
            </div>
          </motion.nav>
        )}
      </AnimatePresence>
    </header>
  );
};
